import { useDisclosure } from "@mantine/hooks";
import { OrganizationsModel } from "../../model/OrganizationsModel";
import { useEffect, useState } from "react";
import Repository from "../../_base/helper/HttpHelper";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { hasLength, useForm } from "@mantine/form";
import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  FileButton,
  Flex,
  Grid,
  Group,
  Image,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import {
  getBranchSelect,
  getDepartmentSelect,
  getRoleSelect,
} from "../../const/getSelectApi";
import {
  IconWindow,
  IconCheck,
  IconUpload,
  IconTrash,
} from "@tabler/icons-react";
import {  repositorySign } from "../../_base/_const/_constVar";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { TblDepartmentModel } from "../../model/TblDepartmentModel";
import { uploadFile } from "../../_base/extension/Extension";
import { UserModel } from "../../model/UserModel";
import { ImageCore } from "../Flow-step/ImageCore";


const UserCreateView = ({ onClose }: OrganizationCreateViewProps) => {
  const entity: UserModel = {
    id: 0,
    userName: "",
    passwordHash: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    avatar: "",
    forgotHash: "",
    imageSignatures: "",
    backgroundSignatures: "",
    digitalSignatures: "",
    defaultSignature: "",
    cloudSignatures: "",
    notSendMailTemplateKey: "",
    tsv: "",
    code: "",
    roleId: "",
    departmentId: "",
  };

  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [fileSign, setFileSign] = useState<File | null>(null);
  const [visible, { close, open }] = useDisclosure(false);

  async function getBranch() {
    const data = await getDepartmentSelect();
    if (data && data.length > 0) setDataBranch(data);
  }

  const form = useForm<UserModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    transformValues: (values) => ({
      ...values,
    }),
    validate: {
      name: (value) => {
        if (!value) return "Tên không được để trống";
        return null;
      },
      passwordHash: hasLength(
        { min: 6, max: 19 },
        "Mật khẩu phải từ 6 và nhỏ hơn 20 kí tự!"
      ),
      email: (value) => {
        if (!value) return "Email không được để trống";
        return null;
      },
      // phone: (value) => {
      //   if (!value) return "Số điện thoại không được để trống";
      //   return null;
      // },
      roleId: (value) => {
        if (!value) return "Vui lòng chọn chức vụ";
        return null;
      },
      departmentId: (value) => {
        if (!value) return "Vui lòng chọn phòng ban";
        return null;
      },
    },
  });

  const handleSetEntity = async () => {
    let url = "/api/v1/users/create";
    let callApi = await repositorySign.get<MessageResponse<UserModel>>(url);
    if (callApi?.success) {
      form.initialize(callApi.data);
    } else {
      NotificationExtension.Fails("Lỗi !");
    }
  };

  const handleCreateDepartment = async (payload: UserModel) => {
    open();
    // const _url = await uploadFile(fileSign ? [fileSign] : []);
    // if (!_url) {
    //   NotificationExtension.Fails("Lỗi tải ảnh, xin thử lại !");
    //   return;
    // }

    // const toBase64 = async (url: string) => {
    //   const response = await fetch(url);
    //   const blob = await response.blob();
    //   return new Promise<string>((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.onloadend = () => resolve(reader.result as string);
    //     reader.onerror = reject;
    //     reader.readAsDataURL(blob);
    //   });
    // };

    // try {
    //   payload.avatar = await toBase64(_url[0].url);
    // } catch (error) {
    //   NotificationExtension.Fails("Lỗi chuyển đổi Base64, xin thử lại !");
    // }

    let url = "/api/v1/Users/create";
    let callApi = await repositorySign.post<MessageResponse<boolean>>(
      url,
      payload
    );

    if (callApi?.httpStatusCode === 200) {
      if (callApi?.success) {
        await onClose();
        modals.closeAll();
        NotificationExtension.Success("Thành công !");
      } else NotificationExtension.Fails("Thất bại !");
    }

    close();
  };

  useEffect(() => {
    handleSetEntity();
    getBranch();
  }, []);

  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);
  const [dataFetchRole, setDataFetchRole] = useState<SelectListItem[]>([]);

  useEffect(() => {
    getDepartmentSelect().then((x) => {
      setDataFetch(x);
    });
    getRoleSelect().then((x) => {
      setDataFetchRole(x);
    });
  }, []);

  const [imageUrl, setImageUrl] = useState<string | null>("");

  useEffect(() => {
    if (fileSign) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        setImageUrl(imageUrl);
        form.setFieldValue("avatar", imageUrl);
      };
      fileReader.readAsDataURL(fileSign ?? new Blob());
    } else {
      setImageUrl(null);

      form.setFieldValue("avatar", "");
    }
  }, [fileSign]);
  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: UserModel) => {
          handleCreateDepartment(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        ></LoadingOverlay>
        <Fieldset legend="Thông tin đăng nhập">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <TextInput
                key={form.key("email")}
                label="Email"
                withAsterisk
                placeholder="Nhập Email"
                {...form.getInputProps("email")}
              ></TextInput>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <TextInput
                key={form.key("passwordHash")}
                label="Mật khẩu đăng nhập"
                withAsterisk
                placeholder="Vui long nhập mật khẩu"
                {...form.getInputProps("passwordHash")}
              ></TextInput>{" "}
            </Grid.Col>
          </Grid>
        </Fieldset>

        <Fieldset legend="Quyền hạn">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Select
                withAsterisk
                id="departmentId"
                key={form.key("departmentId")}
                label="Đơn vị/phòng ban"
                placeholder="Vui lòng chọn đơn vị/phòng ban"
                data={dataFetch?.map((item) => {
                  return {
                    label: item.text,
                    value: item.value.toString(),
                  };
                })}
                nothingFoundMessage="Không có dữ liệu"
                searchable
                clearable
                {...form.getInputProps("departmentId")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Select
                withAsterisk
                id="roleId"
                key={form.key("roleId")}
                label="Chức vụ"
                placeholder="Vui lòng chọn chức vụ"
                data={dataFetchRole?.map((item) => {
                  return {
                    label: item.text,
                    value: item.value,
                  };
                })}
                nothingFoundMessage="Không có dữ liệu"
                searchable
                clearable
                {...form.getInputProps("roleId")}
              />
            </Grid.Col>
          </Grid>
        </Fieldset>
        <Fieldset legend="Thông tin cá nhân">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <TextInput
                key={form.key("name")}
                label="Họ và tên"
                withAsterisk
                placeholder="Nhập họ và tên"
                {...form.getInputProps("name")}
              ></TextInput>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <TextInput
                // withAsterisk
                key={form.key("phone")}
                label="Số điện thoại"
                placeholder="Nhập số điện thoại"
                {...form.getInputProps("phone")}
              ></TextInput>
            </Grid.Col>

            <Grid.Col span={{ base: 12 }}>
              <Textarea
                key={form.key("address")}
                label="Địa chỉ"
                placeholder="Nhập địa chỉ"
                {...form.getInputProps("address")}
              ></Textarea>
            </Grid.Col>
          </Grid>
        </Fieldset>

        <Fieldset legend="Ảnh đại diện">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <FileButton
                onChange={(file) => setFileSign(file)}
                accept="image/png"
              >
                {(props) => (
                  <Button
                    size="xs"
                    variant="outline"
                    leftSection={<IconUpload />}
                    {...props}
                  >
                    Chọn ảnh PNG
                  </Button>
                )}
              </FileButton>
              <Button
                ml={"xs"}
                size="xs"
                variant="outline"
                color="red"
                leftSection={<IconTrash />}
                onClick={() => setFileSign(null)}
              >
                Xóa ảnh
              </Button>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <ImageCore src={imageUrl ?? ""} />
            </Grid.Col>
          </Grid>
        </Fieldset>
        <Group
          mt={20}
          justify="end"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            padding: "5px",
            zIndex: 999,
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color="blue"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
        </Group>
      </Box>
    </>
  );
};

type OrganizationCreateViewProps = {
  onClose: any;
};

export default UserCreateView;
